const Button = {
  variants: {
    solid: {
      bg: 'primary',
      color: 'white',
      _hover: {
        bg: 'primaryOpaque',
        color: 'primary',
      },
    },
  },
};

export default Button;
